import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { isNullUndefinedOrEmpty } from "../../common/Helpers";


const getElementsDataserie = (elementId) => {
    return axios.get(`/api/SkVariable/elementsdataserie/${elementId}/list`, { headers: authHeaderJson() })    
};

const getElementsPossibleSelection = (appElementId, forceGet) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Board/elementsselection/${appElementId}/${forceGet}/list`, { headers: authHeaderJson() } );
};

const getElementRoles = (elementId) => {
    return axios.get(`/api/Board/roles/${elementId}/list`, { headers: authHeaderJson() })    
};

const addListBoardElementDataserie = (boardId, listVariableElements) => {
    return axios.put(`/api/Board/boardelementdataserie/${boardId}/list`, listVariableElements, { headers: authHeaderJson() });
};

const saveUsersByElementId = (elementId,  listUsers) => {
    return axios.put(`/api/Board/elementmember/${elementId}/list`, listUsers, { headers: authHeaderJson() });
};

const deleteElementUserById = (elementId) => {
    return axios.delete(`/api/Board/elementmember/${elementId}`, { headers: authHeaderJson() });
}

const updateElementUserById = (elementId, elementMember) => {
    return axios.put(`/api/Board/elementmember/${elementId}`, elementMember, { headers: authHeaderJson() });
};

const getContractByElementId = (elementId) => {
    return axios.get(`/api/Contract/contractelement/${elementId}`, { headers: authHeaderJson() } );
};

const getContractHeaderByElementId = (elementId) => {
    return axios.get(`/api/Contract/contractelement/${elementId}/header`, { headers: authHeaderJson() } );
};

const getUsersMemberByElementId = (elementId) => {
    return axios.get(`/api/Board/elementmember/${elementId}/list`, { headers: authHeaderJson() } );
};

const getUsersCandidatesByElementId = (elementId) => {
    return axios.get(`/api/Board/elementmembercandidates/${elementId}/list`, { headers: authHeaderJson() } );
};

const getElementUserById = (elementUserId) => {
    return axios.get(`/api/Board/elementmember/${elementUserId}`, { headers: authHeaderJson() } );
};

const getUsers = (legalEntity) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/Env/getUsersLEBU/${isNullUndefinedOrEmpty(legalEntity) ? 0 : legalEntity}`, { headers: authHeaderJson() } );
};

const getElementsBoardPossibleSelection = (appElementId) => {
    return axios.get(`/api/Board/elementsboardselection/${appElementId}/list`, { headers: authHeaderJson() } );
};



export {
    addListBoardElementDataserie,
    getElementsDataserie,
    getElementRoles,
    saveUsersByElementId,
    deleteElementUserById,
    updateElementUserById,
    getContractByElementId,
    getContractHeaderByElementId,
    getUsersMemberByElementId,
    getUsers,
    getElementUserById,
    getUsersCandidatesByElementId,

    getElementsPossibleSelection,
    getElementsBoardPossibleSelection
}